import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const conductorOne = defineConnector({
  identifier: "conductorOne",
  name: "ConductorOne",
  tagLine: "Identity governance and access",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.conductor\\.one/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in ConductorOne",
      items: [
        {
          kind: "markdown",
          content: `1. In ConductorOne, go to **Settings › API Keys**
2. Click “Create API Key”
3. Copy the Client ID and Client Secret`,
        },
      ],
    },
    {
      title: "Enter your ConductorOne details",
      items: [
        {
          kind: "hostname",
          label: "Tenant hostname",
          required: true,
          placeholder: "acme.conductor.one",
          target: { kind: "configuration", field: "tenant" },
          helperText:
            "The full hostname of your ConductorOne tenant (e.g., “acme.conductor.one”).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenant }) => `https://${tenant}/auth/v1/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
    // C1 serializes its token response from protobuf JSON, which emits
    // unpopulated optional fields (e.g. `"refresh_token": ""`) that strict
    // RFC 6749 validation rejects; unset means the same as absent here.
    normalizeTokenResponse: (body) =>
      Object.fromEntries(
        Object.entries(body).filter(
          ([, value]) => value !== null && value !== ""
        )
      ),
  },
  connectionTest: {
    protocol: "http",
    request: ({ tenant }) => `https://${tenant}/api/v1/auth/introspect`,
  },
  publicEnvVars: ({ tenant }) => ({
    CONDUCTOR_ONE_URL: tenant ? `https://${tenant}` : "",
  }),
});
